<template>
  <mobile-responsive-shell title="Paiements clients">
    <div class="pay-m">
      <div class="pay-m-toolbar">
        <button type="button" class="btn btn-outline-secondary btn-sm" @click="refresh">
          <i class="bi bi-arrow-clockwise"></i>
        </button>
        <button type="button" class="btn btn-outline-secondary btn-sm" @click="printList">
          <i class="bi bi-printer"></i>
        </button>
        <button
          type="button"
          class="btn btn-primary btn-sm"
          @click="$router.push({ name: 'mobile-payments-customers-create' })"
        >
          <i class="bi bi-plus-lg"></i> Paiement
        </button>
        <button
          type="button"
          class="btn btn-outline-secondary btn-sm"
          :class="{ active: showFilters }"
          @click="showFilters = !showFilters"
        >
          <i class="bi bi-funnel"></i> Filtres
        </button>
      </div>

      <div v-show="showFilters" class="pay-m-filters card card-body py-3 mb-3">
        <div class="mb-2">
          <label class="form-label small mb-0">Client <span class="text-danger">*</span></label>
          <select v-model="filter.customer_reference" class="form-select form-select-sm" required>
            <option value="">—</option>
            <option
              v-for="(customer, index) in customers"
              :key="index"
              :value="customer.reference"
              :style="customer.blocked || (customer.fullName && customer.fullName.includes('Bloqué')) ? { color: 'red' } : {}"
            >
              {{ customer.fullName }}
            </option>
          </select>
        </div>
        <div class="row g-2 mb-2">
          <div class="col-6">
            <label class="form-label small mb-0">Du <span class="text-danger">*</span></label>
            <input v-model="filter.startDate" type="date" class="form-control form-control-sm" />
          </div>
          <div class="col-6">
            <label class="form-label small mb-0">Au <span class="text-danger">*</span></label>
            <input v-model="filter.endDate" type="date" class="form-control form-control-sm" />
          </div>
        </div>
        <div class="mb-2">
          <label class="form-label small mb-0">Mode de paiement</label>
          <select v-model="filter.paymentMethod" class="form-select form-select-sm">
            <option value="">Tous</option>
            <option value="Espèce">Espèce</option>
            <option value="Virement bancaire">Virement bancaire</option>
            <option value="Chèque">Chèque</option>
            <option value="Effet">Effet</option>
          </select>
        </div>
        <button type="button" class="btn btn-secondary btn-sm w-100" @click="toFilter">
          <i class="bi bi-funnel"></i> Rechercher
        </button>
      </div>

      <p v-if="!payments || !payments.length" class="text-muted text-center py-4">
        Aucun paiement.
      </p>

      <div v-else class="pay-m-list">
        <article
          v-for="(row, idx) in payments"
          :key="row.reference || idx"
          class="pay-m-card"
        >
          <header class="pay-m-head">
            <span class="pay-m-ref">{{ row.reference }}</span>
            <button
              type="button"
              class="btn btn-sm btn-outline-primary"
              @click="goDetails(row)"
            >
              <i class="bi bi-eye"></i>
            </button>
          </header>
          <div class="pay-m-meta">{{ row.customerFullName || "—" }} · {{ row.date || "—" }}</div>
          <div class="pay-m-stats">
            <div><span class="lbl">Montant</span><span class="text-success fw-semibold">{{ fmt(row.amount) }}</span></div>
            <div><span class="lbl">Mode</span><span>{{ row.paymentMethod || "—" }}</span></div>
            <div v-if="row.sale_reference"><span class="lbl">BL</span><span>{{ row.sale_reference }}</span></div>
            <div v-if="row.order_reference"><span class="lbl">BC</span><span>{{ row.order_reference }}</span></div>
            <div v-if="row.invoice_reference"><span class="lbl">Facture</span><span>{{ row.invoice_reference }}</span></div>
            <div v-if="row.passPermit"><span class="lbl">LP</span><span>LP{{ row.passPermit }}</span></div>
          </div>
          <div v-if="row.remark" class="pay-m-remark small text-muted">{{ row.remark }}</div>
          <footer v-if="row.userFullName" class="pay-m-foot small text-muted">{{ row.userFullName }}</footer>
        </article>
      </div>

      <div v-if="payments && payments.length" class="pay-m-summary">
        <div>Montants Σ <strong>{{ fmt(totalAmount) }}</strong></div>
      </div>
    </div>
  </mobile-responsive-shell>
</template>

<script>
import { mapGetters } from "vuex";
import MobileResponsiveShell from "../components/MobileResponsiveShell.vue";

function defaultFilter() {
  return {
    customer_reference: "",
    startDate: new Date(new Date().setFullYear(new Date().getFullYear()))
      .toLocaleString("en-CA")
      .split(",")[0],
    endDate: new Date(new Date().setFullYear(new Date().getFullYear()))
      .toLocaleString("en-CA")
      .split(",")[0],
    paymentMethod: "",
  };
}

export default {
  name: "MobilePaymentsCustomersListing",
  components: { MobileResponsiveShell },
  data() {
    return {
      showFilters: false,
      filter: defaultFilter(),
    };
  },
  computed: {
    ...mapGetters("payment", {
      payments: "getAll",
      totalAmount: "getTotalAmount",
    }),
    ...mapGetters("customer", { customers: "getAll" }),
  },
  mounted() {
    this.$store.dispatch("payment/getAll");
    this.$store.dispatch("customer/getAll");
  },
  methods: {
    fmt(v) {
      if (v === undefined || v === null || v === "") return "—";
      const n = parseFloat(v);
      if (Number.isNaN(n)) return String(v);
      return n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
    async refresh() {
      await this.$store.dispatch("payment/getAll");
    },
    async toFilter() {
      await this.$store.dispatch("payment/filter", { ...this.filter });
    },
    async printList() {
      await this.$store.dispatch("payment/print", { ...this.filter });
    },
    goDetails(row) {
      this.$router.push({
        name: "mobile-payments-customers-details",
        params: { reference: row.reference },
      });
    },
  },
};
</script>

<style scoped>
.pay-m-toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
}
.pay-m-filters {
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.08);
}
.pay-m-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
.pay-m-card {
  background: #fff;
  border-radius: 12px;
  padding: 0.875rem 1rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.07);
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.pay-m-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.35rem;
}
.pay-m-ref {
  font-weight: 700;
  font-size: 0.95rem;
  word-break: break-all;
}
.pay-m-meta {
  font-size: 0.85rem;
  color: #495057;
  margin-bottom: 0.5rem;
}
.pay-m-stats {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.35rem 0.75rem;
  font-size: 0.85rem;
}
.pay-m-stats .lbl {
  display: block;
  font-size: 0.65rem;
  text-transform: uppercase;
  color: #6c757d;
}
.pay-m-remark {
  margin-top: 0.5rem;
  padding-top: 0.5rem;
  border-top: 1px solid #eee;
}
.pay-m-foot {
  margin-top: 0.35rem;
}
.pay-m-summary {
  margin-top: 1rem;
  padding: 0.75rem;
  background: #f8f9fa;
  border-radius: 10px;
  font-size: 0.85rem;
}
</style>
